export default {
  name: "Declaration of Employer and Attorney/Agent",
  pageInfo: {
    text: "The employer must read and agree to all the applicable terms, assurances, and obligations as a condition for receiving a temporary agricultural labor certification from the U.S. Department of Labor.",
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        // V2
        {
          code: "F.1",
          machine_name: "f1_is_appendix_a_complete",
          name: "Appendix A Employer",
          widget: "file_upload",
          label:
            '<span>A signed and dated <a href="https://flag.dol.gov/sites/default/files/2024-08/Form_ETA-9142A_Appendix_A.pdf" rel="noopener noreferrer" target="_blank">Appendix A</a> for the employer identified in Section B of this application is attached.</span>',
          fileTypes: [".pdf", ".png", ".jpg"],
          validate: ["required", "checkValue"],
          isVisible: {
            when: "formVersionId",
            is: [2, 3],
            operator: "||",
          },
          tooltip:
            "Mark “Yes” to confirm that the employer and attorney/agent (1) have read and agree to all the applicable terms, assurances, and obligations in Appendix A, (2) signed and dated Appendix A, and (3) submitted the signed and dated Appendix A with this application.",
        },
        // V1
        {
          code: "F.1",
          machine_name: "f1_is_appendix_a_complete",
          name: "Appendix A Employer",
          widget: "file_upload",
          label:
            '<span>Read and agree to all the application terms, assurances, and obligations contained in <a href="https://flag.dol.gov/sites/default/files/2024-08/Form_ETA-9142A_Appendix_A.pdf" rel="noopener noreferrer" target="_blank">Appendix A</a> and attach a signed and dated copy with this application.</span>',
          fileTypes: [".pdf", ".png", ".jpg"],
          validate: ["required", "checkValue"],
          isVisible: {
            when: "formVersionId",
            is: 1,
          },
          tooltip:
            "Mark “Yes” to confirm that the employer and attorney/agent (1) have read and agree to all the applicable terms, assurances, and obligations in Appendix A, (2) signed and dated Appendix A, and (3) submitted the signed and dated Appendix A with this application.",
        },
        // V2
        {
          code: "F.2",
          machine_name: "f2_is_joint_appendix_a_complete",
          name: "Appendix A Joint Employer",
          widget: "file_upload",
          required: true,
          label:
            '<span>Except for agricultural associations filing as a joint employer,  a separate signed and dated <a href="https://flag.dol.gov/sites/default/files/2024-08/Form_ETA-9142A_Appendix_A.pdf" rel="noopener noreferrer" target="_blank">Appendix A</a> for each employer identified <u>as a joint employer</u> on the job order (Form ETA-790/790A) is attached. </span>',
          fileTypes: [".pdf", ".png", ".jpg"],
          validate: [
            {
              requiredWithCustomMessage:
                "You indicated this application will be filed by or on behalf of two or more employers (non-association).  Please remember that each employer seeking to jointly employ H-2A workers under this application must be identified on the Form ETA-790A, Addendum B, and separately submit a signed and dated Appendix A.",
            },
          ],
          tooltip:
            "If “Joint Employer” is marked in Section A, Question 1, and “Association – Joint Employer” is not marked in Section A, Question 1a, mark “Yes” here to indicate that (1) each of the joint employers included in this application has read and agrees to all the applicable terms, assurances, and obligations contained in Appendix A, (2) each joint employer has signed and dated a copy of Appendix A, and (3) a signed and dated Appendix A for <u>each</u> joint employer is submitted with this application. If any other employer application type is marked in Section A, Questions 1 and 1a, mark <b>“N/A”</b> here.",
          isVisible: {
            when: "a1_employer_type formVersionId",
            is: [["joint"], [2, 3]],
            operator: "compareMultiFieldValuesAND_ORInArray",
          },
        },
        // V1
        {
          code: "F.2",
          machine_name: "f2_is_joint_appendix_a_complete",
          name: "Appendix A Joint Employer",
          widget: "file_upload",
          required: true,
          label:
            '<span>Confirm that each employer filing as a joint employer on the job order (Form ETA-790/790A) has read and agree to all the applicable terms, assurances and obligations contained in <a href="https://flag.dol.gov/sites/default/files/2024-08/Form_ETA-9142A_Appendix_A.pdf" rel="noopener noreferrer" target="_blank">Appendix A</a> and has attached a separate signed and dated copy of <i>Appendix A</i> with this application.</span>',
          fileTypes: [".pdf", ".png", ".jpg"],
          validate: [
            {
              requiredWithCustomMessage:
                "You indicated this application will be filed by or on behalf of two or more employers (non-association).  Please remember that each employer seeking to jointly employ H-2A workers under this application must be identified on the Form ETA-790A, Addendum B, and separately submit a signed and dated Appendix A.",
            },
          ],
          tooltip:
            "If “Joint Employer” is marked in Section A, Question 1, and “Association – Joint Employer” is not marked in Section A, Question 1a, mark “Yes” here to indicate that (1) each of the joint employers included in this application has read and agrees to all the applicable terms, assurances, and obligations contained in Appendix A, (2) each joint employer has signed and dated a copy of Appendix A, and (3) a signed and dated Appendix A for <u>each</u> joint employer is submitted with this application. If any other employer application type is marked in Section A, Questions 1 and 1a, mark <b>“N/A”</b> here.",
          isVisible: {
            when: "a1_employer_type formVersionId",
            is: [["joint"], [1]],
            operator: "compareMultiFieldValuesAND_ORInArray",
          },
        },
        {
          code: "I5",
          machine_name: "files",
          widget: "text",
          hidden: true,
        },
      ],
    },
  ],
};
